import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import transformContentHtml from "@insite/client-framework/Common/Utilities/transformContentHtml";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import { CartLineModel, OrderLineModel } from "@insite/client-framework/Types/ApiModels";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { LinkPresentationProps } from "@insite/mobius/Link";
import { TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS } from "@tCentro/theme/design";
import parse from "html-react-parser";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps {
    product: CartLineModel | ProductContextModel | OrderLineModel;
    extendedStyles?: CENProductDescriptionStyles;
}

type Props = OwnProps;

export interface CENProductDescriptionStyles {
    productDetailLink?: LinkPresentationProps;
    productDetailDescription?: TypographyProps;
}

export const cenProductDescriptionStyles: CENProductDescriptionStyles = {
    productDetailDescription: {
        css: css`
            display: -webkit-box;
            -webkit-line-clamp: 10;
            -webkit-box-orient: vertical;
            overflow: hidden;
            width: 100%;
            font-weight: 400;
            font-size: 12px;
            line-height: 16px;
            color: ${getColor("text.main")};
            margin-bottom: 16px;
            padding: 0px 5px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-left: 0px;
                    `,
                    css`
                        padding-left: 0px;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
};

const CENProductDescription: FC<Props> = ({ product, extendedStyles }) => {
    const [styles] = React.useState(() => mergeToNew(cenProductDescriptionStyles, extendedStyles));
    const description = "product" in product ? product.product.content?.htmlContent : "";

    if (!description) {
        return null;
    }
    return (
        <StyledWrapper data-test-selector="productDetailDescription" {...styles.productDetailDescription}>
            {parse(transformContentHtml(description), parserOptions)}
        </StyledWrapper>
    );
};

export default CENProductDescription;
